import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import SellTradeLayout from "@/pages/sell-my-car/layout/SellTradeLayout";
import FLowHeader from "@/pages/sell-my-car/components/FLowHeader";
import FlowBody from "@/pages/sell-my-car/components/FlowBody";
import { ScreenNavigationProvider, useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { SellCarDataProvider, useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import { Switch } from "@componentsShared/Conditional/Switch";
import { Case } from "@componentsShared/Conditional/Case";
import { Default } from "@componentsShared/Conditional/Default";
import CarBrandScreen from "@/pages/sell-my-car/screens/CarBrandScreen";
import CarModelScreen from "@/pages/sell-my-car/screens/CarModelScreen";
import CarYearScreen from "@/pages/sell-my-car/screens/CarYearScreen";
import CarTrimScreen from "@/pages/sell-my-car/screens/CarTrimScreen";
import ContactInfoScreen from "@/pages/sell-my-car/screens/ContactInfoScreen";
import CarOdometerScreen from "@/pages/sell-my-car/screens/CarOdometerScreen";
import CarOwnerShipScreen from "@/pages/sell-my-car/screens/CarOwnerShipScreen";
import EstimatedPriceScreen from "@/pages/sell-my-car/screens/EstimatedPriceScreen";
import CancelConfirmation from "@/pages/sell-my-car/components/CancelConfirmation";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
import CarLocationPickedScreen from "@/pages/sell-my-car/screens/CarLocationPickedScreen";
import CarBookingDateTime from "@/pages/sell-my-car/screens/CarBookingDateTime";
import CarPaymentScreen from "@/pages/sell-my-car/screens/CarPaymentScreen";
import PaymentSuccessScreen from "@/pages/sell-my-car/screens/PaymentSuccessScreen";
import PaymentFailedScreen from "@/pages/sell-my-car/screens/PaymentFailedScreen";
import CarBookingSuccessScreen from "@/pages/sell-my-car/screens/CarBookingSuccessScreen";
import CarRejectedScreen from "@/pages/sell-my-car/screens/CarRejectedScreen";
import CarLocationNotApprovedForInspectionScreen from "@/pages/sell-my-car/screens/CarLocationNotApprovedForInspectionScreen";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { trackEvents } from "@/common/events/events";
import { If } from "@componentsShared/Conditional/If";
import useIsWebView from "@hooks/useIsWebview";
import { CDN_LINK } from "@globalConfig";
import CarInitialScreen from "@/pages/sell-my-car/screens/CarInitialScreen";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var nonLayoutScreens = [SELL_CAR_SCREENS.BOOKING_SUCCESS, SELL_CAR_SCREENS.PAYMENT_SUCCESS, SELL_CAR_SCREENS.PAYMENT_FAILED, SELL_CAR_SCREENS.REJECTED, SELL_CAR_SCREENS.NOT_APPROVED_FOR_INSPECTION];
var SellMyCarRoot = function SellMyCarRoot() {
  var navigate = useNavigate();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var isMobile = useIsMobile();

  // Prevent iOS overscroll/bounce that causes content to go beneath status bar (mobile only)
  useEffect(function () {
    if (!isMobile) return;
    var originalOverflow = document.body.style.overflow;
    var originalOverscroll = document.body.style.overscrollBehavior;
    var originalPosition = document.body.style.position;
    document.body.style.overflow = 'hidden';
    document.body.style.overscrollBehavior = 'none';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    return function () {
      document.body.style.overflow = originalOverflow;
      document.body.style.overscrollBehavior = originalOverscroll;
      document.body.style.position = originalPosition;
      document.body.style.width = '';
    };
  }, [isMobile]);

  // Redirect to login if user is not logged in and there's a request_id
  useEffect(function () {
    var requestId = searchParams.get('request_id');
    var status = searchParams.get('status');

    // If there's a request_id and user is not logged in, redirect to login
    // Don't redirect if payment has failed (we're redirecting to failed page anyway)
    if (requestId && !isLoggedIn && status !== 'failed') {
      // Preserve the current URL to return after login
      var returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      navigate(createUrl("/user/signup", {
        returnTo: returnUrl
      }), {
        replace: true
      });
    }
  }, [searchParams, isLoggedIn, navigate, createUrl]);
  return /*#__PURE__*/React.createElement(SellCarDataProvider, null, /*#__PURE__*/React.createElement(ScreenNavigationProvider, {
    initialScreen: SELL_CAR_SCREENS.CAR_MAKE,
    baseKey: "sell-car-flow",
    syncWithURL: true,
    urlParamName: "step"
  }, /*#__PURE__*/React.createElement(SellCarLayoutWrapper, null)));
};
var SellCarLayoutWrapper = function SellCarLayoutWrapper() {
  var _carData$draftOrder2, _carData$draftOrder3;
  var cancelModal = useBoolean();
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useScreenNavigation = useScreenNavigation(),
    state = _useScreenNavigation.state,
    navActions = _useScreenNavigation.actions;
  var _useSearchParams3 = useSearchParams(),
    _useSearchParams4 = _slicedToArray(_useSearchParams3, 1),
    searchParams = _useSearchParams4[0];
  var _useSellCarData = useSellCarData(),
    carData = _useSellCarData.state,
    dataActions = _useSellCarData.actions;
  var requestId = searchParams.get('request_id');
  var _useState = useState(false),
    isCancelling = _useState[0],
    setIsCancelling = _useState[1];
  var _useHelpers2 = useHelpers(),
    navigateToHard = _useHelpers2.navigateToHard,
    createUrl = _useHelpers2.createUrl;
  var isWebView = useIsWebView();
  var _useSession2 = useSession(),
    isLoggedIn = _useSession2.isLoggedIn;
  var _useState2 = useState(false),
    hasFetchedStepData = _useState2[0],
    setHasFetchedStepData = _useState2[1];

  // Fetch step data at wrapper level to avoid circular dependency
  useEffect(function () {
    var _carData$draftOrder;
    var status = searchParams.get('status');

    // Skip fetch if step data was already set (e.g., after submit in ContactInfoScreen)
    var hasExistingStepData = !!(carData !== null && carData !== void 0 && (_carData$draftOrder = carData.draftOrder) !== null && _carData$draftOrder !== void 0 && _carData$draftOrder.currentStep);
    if (requestId && status !== 'failed' && isLoggedIn && !hasFetchedStepData && !hasExistingStepData) {
      setHasFetchedStepData(true);

      // Capture payment redirect params before clearing URL
      var _paymentStatus = searchParams.get('status');
      var paymentMessage = searchParams.get('message');
      var moyasarId = searchParams.get('id');
      if (_paymentStatus || paymentMessage || moyasarId) {
        dataActions.setPaymentRedirectParams({
          status: _paymentStatus || undefined,
          message: paymentMessage || undefined,
          moyasarId: moyasarId || undefined
        });
      }
      dataActions.fetchStepData().then(function (res) {
        var _res$current_step;
        var currentStepKey = res === null || res === void 0 ? void 0 : (_res$current_step = res.current_step) === null || _res$current_step === void 0 ? void 0 : _res$current_step.step_key;
        if (currentStepKey) {
          var newURL = createUrl("/site/sell-my-car", {
            request_id: requestId
          });
          window.history.replaceState({}, null, newURL);
          navActions.navigateToScreen(currentStepKey);
        }
      });
    }
  }, [requestId, isLoggedIn, hasFetchedStepData, searchParams, dataActions, navActions, createUrl, carData === null || carData === void 0 ? void 0 : (_carData$draftOrder2 = carData.draftOrder) === null || _carData$draftOrder2 === void 0 ? void 0 : _carData$draftOrder2.currentStep]);
  var handleCancelClick = function handleCancelClick() {
    if (requestId) {
      var url = createUrl(URL_SELL_TRADE_LANDING_v2);
      navigateToHard(url);
      return;
    }
    cancelModal.setTrue();
  };
  var handleCancelConfirm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // If we have request_id, we're after contact info submission
            // Call cancel API
            if (requestId) {
              setIsCancelling(true);
              cancelModal.setFalse();
              // Navigate to landing page
              navigateToHard(URL_SELL_TRADE_LANDING_v2);
            } else {
              setIsCancelling(false);
              cancelModal.setFalse();
              trackEvents("sell_car_request_cancel", {
                platform: getPlatformInfo(),
                request_id: "null",
                cancel_stage: "pre_lead",
                cancellation_reason: "null"
              });
              navigateToHard(URL_SELL_TRADE_LANDING_v2);
            }
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCancelConfirm() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleCancelDismiss = function handleCancelDismiss() {
    cancelModal.setFalse();
  };

  // Show loading screen while:
  // 1. carData is not loaded yet
  // 2. carData is loading
  // 3. SSR
  // 4. We have a request_id but haven't loaded step data yet (draftOrder.currentStep is null)
  //    Exception: Don't wait for step data if payment has failed (let redirect logic handle it)
  var paymentStatus = searchParams.get('status');
  var isPaymentFailed = paymentStatus === 'failed';
  var isWaitingForStepData = requestId && !(carData !== null && carData !== void 0 && (_carData$draftOrder3 = carData.draftOrder) !== null && _carData$draftOrder3 !== void 0 && _carData$draftOrder3.currentStep) && !isPaymentFailed;
  if (!carData || carData !== null && carData !== void 0 && carData.isLoading || __IS_SSR__ || isWaitingForStepData) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CarInitialScreen, null));
  }

  // Check if current screen should be rendered without layout
  var isNonLayoutScreen = nonLayoutScreens.includes(state.currentScreen);
  // Render without layout for specific screens
  if (isNonLayoutScreen) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Switch, {
      value: state.currentScreen
    }, /*#__PURE__*/React.createElement(Case, {
      value: SELL_CAR_SCREENS.BOOKING_SUCCESS
    }, /*#__PURE__*/React.createElement(CarBookingSuccessScreen, null)), /*#__PURE__*/React.createElement(Case, {
      value: SELL_CAR_SCREENS.PAYMENT_SUCCESS
    }, /*#__PURE__*/React.createElement(PaymentSuccessScreen, null)), /*#__PURE__*/React.createElement(Case, {
      value: SELL_CAR_SCREENS.REJECTED
    }, /*#__PURE__*/React.createElement(CarRejectedScreen, null)), /*#__PURE__*/React.createElement(Case, {
      value: SELL_CAR_SCREENS.NOT_APPROVED_FOR_INSPECTION
    }, /*#__PURE__*/React.createElement(CarLocationNotApprovedForInspectionScreen, null)), /*#__PURE__*/React.createElement(Default, null, /*#__PURE__*/React.createElement(CarInitialScreen, null))));
  }

  // Render with layout for all other screens
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SellTradeLayout, null, /*#__PURE__*/React.createElement(If, {
    condition: !isWebView
  }, /*#__PURE__*/React.createElement(FLowHeader, {
    onCancel: handleCancelClick
  })), /*#__PURE__*/React.createElement(SellCarFlowContent, null), /*#__PURE__*/React.createElement(CancelConfirmation, {
    isOpen: cancelModal.value,
    onClose: handleCancelDismiss,
    haveClose: true,
    title: tShort("sell_trade_v2/order_confirm_title", {
      ns: "web_sell_trade"
    }),
    icon: CDN_LINK + "/assets/images/exclamation-mark.svg",
    description: tShort("sell_trade_v2/order_confirm_description", {
      ns: "web_sell_trade"
    }),
    confirmButton: {
      text: tShort("sell_trade_v2/confirm_order_button_text", {
        ns: "web_sell_trade"
      }),
      variant: "primary",
      action: handleCancelDismiss
    },
    cancelButton: {
      text: tShort("sell_trade_v2/cancel_order_button_text", {
        ns: "web_sell_trade"
      }),
      variant: "outline",
      action: handleCancelConfirm
    }
  })));
};
var SellCarFlowContent = function SellCarFlowContent() {
  var _useScreenNavigation2 = useScreenNavigation(),
    state = _useScreenNavigation2.state,
    navActions = _useScreenNavigation2.actions;
  var _useSellCarData2 = useSellCarData(),
    sellCarState = _useSellCarData2.state,
    dataActions = _useSellCarData2.actions;
  var _useSearchParams5 = useSearchParams(),
    _useSearchParams6 = _slicedToArray(_useSearchParams5, 1),
    searchParams = _useSearchParams6[0];
  var navigate = useNavigate();
  var _useHelpers3 = useHelpers(),
    createUrl = _useHelpers3.createUrl;
  var makeIdProcessedRef = useRef(false);

  // Handle payment failure redirect
  useEffect(function () {
    var status = searchParams.get('status');
    var message = searchParams.get('message');
    var requestId = searchParams.get('request_id');

    // If payment failed, redirect to payment failed page
    if (status === 'failed' && message && requestId) {
      navigate(createUrl("/site/sell-my-car/payment-failed/".concat(requestId)), {
        replace: true
      });
    }
  }, [searchParams, navigate, createUrl]);

  // Check if all selection data is null and redirect to car make screen
  useEffect(function () {
    var requestId = searchParams.get('request_id');
    var makeId = searchParams.get('make_id');
    var selection = sellCarState.selection;

    // Don't redirect if user has a request_id (post-contact-info flow)
    // Don't redirect if already on car make screen
    // Don't redirect if make_id exists in URL (make will be populated once brandsData loads)
    if (!requestId && !makeId && state.currentScreen !== SELL_CAR_SCREENS.CAR_MAKE) {
      // Check if all selection data (except selectedCityForInspection) is null
      var isSelectionEmpty = selection.make === null && selection.model === null && selection.extension === null && selection.year === null && selection.odometerRange === null && selection.ownership === null;
      if (isSelectionEmpty) {
        navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_MAKE);
      }
    }
  }, [sellCarState.selection, state.currentScreen, searchParams, navActions]);

  // Populate make from URL parameter if provided
  useEffect(function () {
    var makeId = searchParams.get('make_id');
    var requestId = searchParams.get('request_id');

    // Skip if already processed to prevent re-triggering on back navigation
    if (makeIdProcessedRef.current) {
      return;
    }

    // Only populate if make_id exists, brandsData is loaded, make is not already selected, and no request_id
    if (makeId && sellCarState.brandsData && !sellCarState.selection.make && !requestId) {
      var make = sellCarState.brandsData.makes.find(function (m) {
        return m.id === parseInt(makeId);
      });
      if (make) {
        dataActions.selectMake(make);
        makeIdProcessedRef.current = true;

        // Automatically navigate to the next screen (car model) if we're on car make screen
        if (state.currentScreen === SELL_CAR_SCREENS.CAR_MAKE) {
          navActions.navigateToScreen(SELL_CAR_SCREENS.CAR_MODEL);
        }
      }
    }
  }, [searchParams, sellCarState.brandsData, sellCarState.selection.make, dataActions, state.currentScreen, navActions]);

  // Prevent browser back button when request_id exists
  useEffect(function () {
    var requestId = searchParams.get('request_id');
    if (requestId) {
      var handlePopState = function handlePopState() {
        // Push the current state back to prevent navigation
        window.history.pushState(null, '', window.location.href);
      };

      // Push initial state
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
      return function () {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [searchParams]);

  // Set up callback to clear forward data when navigating back
  useEffect(function () {
    navActions.setOnNavigateBack(function (targetScreen) {
      dataActions.clearForwardDataFromScreen(targetScreen);

      // When navigating back to CAR_MAKE, remove make_id from URL
      // Note: We intentionally do NOT reset makeIdProcessedRef here to prevent
      // a race condition where stale searchParams could trigger re-navigation to car-model
      if (targetScreen === SELL_CAR_SCREENS.CAR_MAKE) {
        var url = new URL(window.location.href);
        if (url.searchParams.has('make_id')) {
          url.searchParams["delete"]('make_id');
          window.history.replaceState(window.history.state, '', url.toString());
        }
      }
    });

    // Cleanup on unmount
    return function () {
      navActions.setOnNavigateBack(null);
    };
  }, [navActions, dataActions]);
  return /*#__PURE__*/React.createElement(FlowBody, {
    expandable: false,
    isExpanded: false
  }, /*#__PURE__*/React.createElement(Switch, {
    value: state.currentScreen
  }, /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_INITIAL
  }, /*#__PURE__*/React.createElement(CarInitialScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_MAKE
  }, /*#__PURE__*/React.createElement(CarBrandScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_MODEL
  }, /*#__PURE__*/React.createElement(CarModelScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_EXTENSION
  }, /*#__PURE__*/React.createElement(CarTrimScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_YEAR
  }, /*#__PURE__*/React.createElement(CarYearScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CONTACT_INFO
  }, /*#__PURE__*/React.createElement(ContactInfoScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_ODOMETER
  }, /*#__PURE__*/React.createElement(CarOdometerScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_OWNERSHIP
  }, /*#__PURE__*/React.createElement(CarOwnerShipScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.ESTIMATED_PRICE
  }, /*#__PURE__*/React.createElement(EstimatedPriceScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_LOCATION_PICKED
  }, /*#__PURE__*/React.createElement(CarLocationPickedScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.CAR_BOOKING_DATE_TIME
  }, /*#__PURE__*/React.createElement(CarBookingDateTime, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.FEES_PAYMENT
  }, /*#__PURE__*/React.createElement(CarPaymentScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.PAYMENT_SUCCESS
  }, /*#__PURE__*/React.createElement(PaymentSuccessScreen, null)), /*#__PURE__*/React.createElement(Case, {
    value: SELL_CAR_SCREENS.PAYMENT_FAILED
  }, /*#__PURE__*/React.createElement(PaymentFailedScreen, null)), /*#__PURE__*/React.createElement(Default, null, /*#__PURE__*/React.createElement(CarInitialScreen, null))));
};
export default SellMyCarRoot;